import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-cream-dark py-14 md:py-20" data-id="element-236">
      <div className="max-w-4xl mx-auto px-6" data-id="element-237">
        {/* First block — full width */}
        <motion.div className="space-y-6 text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} data-id="element-238">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark leading-tight" data-id="element-239">
            La mayoría de las personas atraviesan momentos importantes de su
            vida sin un espacio para honrarlos.
          </h2>

          <div className="space-y-5 font-lora text-lg text-brown-light" data-id="element-240">
            <p data-id="element-241">
              Cuando terminamos relaciones… Cuando perdemos a alguien… Cuando
              empezamos una nueva etapa… Cuando necesitamos cerrar ciclos…
            </p>
            <p className="font-medium text-brown-dark" data-id="element-242">
              No nos enseñaron a ritualizar la vida.
            </p>

            <div data-id="element-243">
              <p className="mb-2" data-id="element-244">Y por eso muchos momentos quedan:</p>
              <ul className="list-disc pl-5 space-y-1 text-brown-dark/80 inline-block text-left" data-id="element-245">
                <li data-id="element-246">inconclusos</li>
                <li data-id="element-247">emocionalmente cargados</li>
                <li data-id="element-248">energéticamente abiertos</li>
              </ul>
            </div>

            <div className="p-5 bg-cream-light border-l-4 border-gold-main rounded-r-sm" data-id="element-249">
              <p className="italic" data-id="element-250">
                El resultado: Personas cargando emociones que nunca pudieron
                integrar.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Second block — full width, stacked below */}
        <motion.div className="mt-12 space-y-5 text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-251">
          <div className="relative rounded-sm overflow-hidden shadow-xl" data-id="element-252">
            <img src="https://cdn.magicpatterns.com/uploads/dokEuDS7oLCkxGhccZmZiq/IMG_9018_1.webp" alt="Ceremonia al aire libre" className="w-full h-auto object-cover aspect-[16/9]" loading="lazy" data-id="element-253" />
            <div className="absolute inset-0 bg-gradient-to-t from-brown-dark/40 to-transparent" data-id="element-254"></div>
          </div>

          <div className="space-y-3" data-id="element-255">
            <h3 className="text-2xl font-playfair font-semibold text-gold-dark" data-id="element-256">
              Aquí es donde los rituales conscientes cambian todo.
            </h3>
            <p className="font-lora text-brown-light" data-id="element-257">
              Un ritual no es solo un objeto, una vela o una ceremonia.
            </p>
            <p className="font-lora text-lg font-medium text-brown-dark" data-id="element-258">
              Un ritual verdadero es un contenedor emocional y energético que te
              permite:
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-lora text-brown-light max-w-md mx-auto text-left" data-id="element-259">
              <li className="flex items-center gap-2" data-id="element-260">
                <span className="text-gold-main" data-id="element-261">✦</span> integrar experiencias
              </li>
              <li className="flex items-center gap-2" data-id="element-262">
                <span className="text-gold-main" data-id="element-263">✦</span> cerrar ciclos
              </li>
              <li className="flex items-center gap-2" data-id="element-264">
                <span className="text-gold-main" data-id="element-265">✦</span> honrar momentos
              </li>
              <li className="flex items-center gap-2" data-id="element-266">
                <span className="text-gold-main" data-id="element-267">✦</span> sanar heridas
              </li>
              <li className="flex items-center gap-2" data-id="element-268">
                <span className="text-gold-main" data-id="element-269">✦</span> abrir nuevas etapas
                con consciencia
              </li>
            </ul>
            <p className="font-lora font-medium text-brown-dark pt-3 border-t border-gold-main/20" data-id="element-270">
              Y eso es exactamente lo que aprenderás en este libro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}